module.exports = __webpack_public_path__ + "img/root10.69cae099.png";